export default {
  methods: {
    compare(p){ //这是比较函数
      return function(m,n){
          var a = m[p];
          var b = n[p];
          return a.localeCompare(b,'zh-CN',{ numeric: true });
    }},
    render_chart4(data, index) {
      data = data.list;
      var time = [...new Set(data.map(v=>v.mouth))].sort()
      console.log(data);
      if(data.length == 1 || data.length<=7) {
        var yearOne = data
        yearTwo = []
        yearThere = []
      }else {
        var yearOne = data.filter(v=>v.mouth == time[0])
        var yearTwo = data.filter(v=>v.mouth == time[1]) || null
        var yearThere = data.filter(v=>v.mouth == time[2]) || null
      }
      // console.log(time);
      // console.log('yearOne',yearOne);
      // console.log('yearTwo',yearTwo);
      // console.log('yearThere',yearThere);
      // console.log(yearOne.map(v=>v.dataList[0].dayNum));
      // console.log(yearTwo.map(v=>v.dataList[0].dayNum));
      let  color = ['#7BFFE0','#D2BA41','#D27841']
      let option = {
          color: color,
          // title: {
          //     text: title,
          //     top: 10,
          //     left: 10
          // },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              },
              formatter: ((params)=>{
                let dayNum = [];
                params.sort(this.compare("seriesName"))
                // const arr = data[params[0].dataIndex].dataList;
                // if(index == 3) {
                //   let str = `${params[0].axisValue}<br/>`
                //   arr.forEach((p) => {
                //     const cont =  `${p.time}<span style="inline-block;text-algin:left; float:right; font-weight:800; margin-left: 20px;">${p.dayNum}</span><br/>`;
                //     dayNum.push(cont);
                //   });
                //   dayNum.unshift(str)
                //   return dayNum.join('');
                // }else {
                  let str = "";
                  let arr = `${params[0].axisValue}<br/>`
                  params.forEach((p) => {
                    str = `${p.marker}${p.seriesName} <span style="inline-block;text-algin:left; float:right; font-weight:800; margin-left: 20px;">${p.value}</span><br/>`;
                    dayNum.push(str);
                  });
                  dayNum.unshift(arr)
                  return dayNum.join('');
                // }
            })
          },
          legend: {
            top: 45,
            data: time,
            data: [
              {
                name: time[0],
                textStyle: {
                  color: color[0],
                  fontFamily: 'PingFangSC',
                }
              },
              {
                name: time[1],
                textStyle: {
                  color: color[1],
                  fontFamily: 'PingFangSC',
                }
              },
              {
                name: time[2],
                textStyle: {
                  color: color[2],
                  fontFamily: 'PingFangSC',
                }
              },
            ]
          },
          grid: {
            top: 80,
            left: 40,
            bottom: 30,
            right: 20,
          },
          xAxis: [
              {
                  type: 'category',
                  data: yearOne.map(v=>v.taskName),
                  axisPointer: {
                      type: 'shadow',
                      label: {
                        fontFamily: 'PingFangSC',
                      } 
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgb(255,255,255,.6)',
                    fontFamily: 'PingFangSC',
                  },
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(255,255,255,.15)',
                    }
                  }
              }
          ],
          yAxis: [
            {    
              name: '天数',
              type: 'value',
              axisLabel: {
                color: 'rgb(255,255,255,.6)',
                fontFamily: 'PingFangSC',
              },
              minInterval: 1,
              axisTick: { show: false },
              axisLine: {
                lineStyle: {
                  color: 'rgba(65,210,144,.3)',
                  fontFamily: 'PingFangSC',
                }
              },
              splitLine: { show: false }
          },
          ],
          series: [
            {
                name: time[0],
                // name: index==2 ? data[0].dataList[0].time : time[0],
                type: 'line',
                // data: index==3 ? yearOne.map(v=>v.dataList[0].tpisTotal) : yearOne.map(v=>v.dataList[0].dayNum),
                data: yearOne.map(v=>v.dataList[0].dayNum),
                // barWidth: 20,
                // label: {
                //   show: true,
                //   position: 'top'
                // }
            },
            {
                name: time[1] || null,
                type: 'line',
                data: yearTwo.map(v=>v.dataList[0].dayNum) || null,
                // label: {
                //   show: true,
                //   position: 'top'
                // }
            },
            {
                name: time[2] || null,
                type: 'line',
                data: yearThere.map(v=>v.dataList[0].dayNum) || null,
                barWidth: 20,
                // label: {
                //   show: true,
                //   position: 'top'
                // }
            },
          ]
      };
      let $instance = this.$echarts.init(this.$refs['node1']);
      // let $instance = this.$echarts.init(this.$refs[`node${index}`]);
      $instance.setOption(option);
    }
  }
}